import React, { useEffect, useContext, useRef } from "react";
import UploadLogoButton from "../UploadLogoButton/UploadLogoButton";
import WalletReceipt from "../WalletReceipt/WalletReceipt";
import GiftWrappingStickers from "../GiftWrappingStickers/GiftWrappingStickers";
import ReceiptWalletFront from "../ReceiptWalletFront/ReceiptWalletFront";
import LuxuryRingBox from "../LuxuryRingBox/LuxuryRingBox";
import crossArrow from "../../assests/icons/crossArrow.svg";
import GiftWrappingPaper from "../GiftWrappingPaper/GiftWrappingPaper";
import LimitedColorPicker from "../LimitedColorPicker";
import { useLocation, useSearchParams } from "react-router-dom";
import LuxuryGiftBags from "../luxuryGiftbags/LuxuryGiftBags";
import BoxSVG from "../../SVGs/box/box";
import BagSVG from "../../SVGs/bag/bags";
import TissueSVG from "../../SVGs/tissue/tissue";
import StickerSVG from "../../SVGs/sticker/sticker";
import ReceiptSVG from "../../SVGs/receipt/receiptOutside";
import logo from "../logoBase";
import rhsBG from "../../SVGs/receipt/layers/rhsBG.png";
import boxlogo from "../../assests/boxlogo.png";
import stickerlogo from "../../assests/stickerlogo.png";
import paperlogo from "../../assests/paperlogo.png";
import { useState } from "react";
import ReceiptSVGInside from "../../SVGs/receipt/receiptInside";
import rhsbg from "../../assests/rhsbg.png";
import { GlobalStateContext } from "../../App";

function RenderControlers(props) {
  var otherColors = Array.from(
    new Set([
      props.state[1].gussetColor,
      props.state[1].bagColor,
      props.state[2].t1Color,
      props.state[2].t2Color,
      props.state[3].color,
      props.state[5].flipColor,
    ])
  );

  const Controllers = [
    LuxuryRingBox,
    LuxuryGiftBags,
    GiftWrappingPaper,
    GiftWrappingStickers,
    ReceiptWalletFront,
    WalletReceipt,
  ];
  const Controller = Controllers[props.id];

  return (
    <Controller
      {...props}
      data={props.state[props.id]}
      otherColors={otherColors}
    />
  );
}

function RenderViews({ id, data }) {
  // For debuging
  // console.log("rendering renderview with", {
  //   id: Math.random().toString(36).substring(2, 7),
  //   data: data,
  // });

  const items = [
    BoxSVG,
    BagSVG,
    TissueSVG,
    StickerSVG,
    ReceiptSVG,
    ReceiptSVGInside,
  ];
  const Item = items[id];

  // return <img src={data.logo} />

  // const renderTwice = <Item {...data} />

  return <Item {...data} />;
}

const staticData = [
  {
    name: "LUXURY RING BOX",
    logo: boxlogo,
    logoSize: "medium",
    innerColor: "#fbffb5",
    // boxColor: "#01452e",
    // boxColor: "#02595A",
    boxColor: "#30504D",
  },
  {
    name: "LUXURY GIFT BAGS",
    logo: boxlogo,
    logoSize: "medium",
    // handleColor: "#013322",
    // gussetColor: "#013322",
    handleColor: "#01452e",
    gussetColor: "#01452e",
    bagColor: "#fff",
  },
  {
    name: "TISSUE PAPER",
    t1Logo: paperlogo,
    t1LogoSize: "medium",
    t2Logo: paperlogo,
    t2LogoSize: "medium",
    t1Color: "#01452e",
    t2Color: "#fcfcf5",
  },
  {
    name: "STICKERS",
    logo: stickerlogo,
    logoSize: "medium",
    color: "#01452e",
  },
  {
    name: "RECEIPT WALLET (COVER)",
    logo: boxlogo,
    logoSize: "medium",
    urlLink: "www.parifypackaging.co.uk",
  },
  {
    name: "RECEIPT WALLET (INSIDE)",
    flipColor: "#01452e",
    introText:
      "Enter your store details here. Fonts and social icons can be changed by our designer upon concept submission.",
    rhsBG: rhsbg,
  },
];

const ColorChanger = ({ data, stage, save }) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const userData = globalState?.userData;

  const [state, setState] = useState();
  const logo = useLocation();

  useEffect(() => {
    if (!state && logo) {
      console.log({ logo, state });
      var stateVal =
        globalState?.design ||
        JSON.parse(localStorage.getItem("state")) ||
        staticData;

      if (logo?.state) {
        stateVal.forEach((element) => {
          var logoBase64 = logo.state;
          if (element.logo) element.logo = logoBase64;
          if (element.t1Logo) element.t1Logo = logoBase64;
          if (element.t2Logo) element.t2Logo = logoBase64;
        });
      }
      localStorage.setItem("state", JSON.stringify(stateVal));
      setState(stateVal);
    }
  }, [logo]);

  useEffect(() => {
    if (userData) {
      sessionStorage.setItem("isStateSaved", false);
      const interval = setInterval(() => {
        const isStateSaved = JSON.parse(sessionStorage.getItem("isStateSaved"));
        const state = JSON.parse(localStorage.getItem("state"));
        if (!isStateSaved) callAPI(userData._id, state);
      }, 10000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [userData]);

  function callAPI(id, state) {
    sessionStorage.setItem("isStateSaved", true);
    fetch("https://friendly-jepsen.77-68-82-89.plesk.page/design/" + id, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ state }),
    });
  }

  const saveState = () => {
    save();
    userData && callAPI(userData._id, state);
  };

  function changeState(key, value, location = parseInt(stage)) {
    const currentState = JSON.parse(JSON.stringify(state));
    currentState[stage][key] = value;
    setState(() => currentState);
    sessionStorage.setItem("isStateSaved", false);

    try {
      localStorage.setItem("state", JSON.stringify(currentState));
    } catch (err) {
      console.log({ err });
    }
  }

  function scaleTgl() {
    const scaleList = document.getElementById("scaleList");
    if (scaleList.style.display != "none") scaleList.style.display = "none";
    else scaleList.style.display = "block";
  }

  function logoScale(size) {
    changeState("logoSize", size);
    scaleTgl();
  }

  return (
    <>
      {state ? (
        <>
          <section className="flex flex-col lg:flex-row items-start gap-8">
            <div>
              {/* Viewer Component */}
              <div className="w-[80vw] lg:w-[600px] aspect-[1/1] bg-white border border-solid border-[#0F0F0F] rounded-lg flex justify-center items-center">
                <RenderViews
                  id={parseInt(stage)}
                  data={state[parseInt(stage)]}
                />
              </div>
              {/* Viewer Component */}
              <div className="flex justify-center items-center gap-4 mt-3">
                {stage === 2 ? (
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-center gap-2">
                      <UploadLogoButton
                        text={"UPLOAD LOGO-1"}
                        btnID={"upload_1"}
                        stage={stage}
                        stateChanger={changeState}
                      />
                      {/* <div className="min-h-screen flex items-center justify-center"> */}
                      <UploadLogoButton
                        text={"UPLOAD LOGO-2"}
                        btnID={"upload_2"}
                        stage={stage}
                        stateChanger={changeState}
                      />
                    </div>
                    {/* </div> */}
                    {/* <div
                        className="text-[13px]"
                        style={{ fontFamily: "ZapfHumanistBold" }}
                      >
                        <p>
                          *For visibility, we recommend to use a white version of your
                          logo on a dark background.
                        </p>
                        <p className="flex ml-24">
                          Black or grey logos work best on white backgrounds.
                        </p>
                      </div> */}
                  </div>
                ) : (
                  <>
                    {stage === 5 ? (
                      <div className="flex flex-col gap-2">
                        <div className="w-[224px] ml-[35px]">
                          <UploadLogoButton
                            text={stage === 5 ? "UPLOAD IMAGE" : "UPLOAD LOGO"}
                            btnID={"upload"}
                            style={"gap-3"}
                            stage={stage}
                            stateChanger={changeState}
                          />
                        </div>
                        {/* <p
                            className="text-[13px]"
                            style={{ fontFamily: "ZapfHumanistBold" }}
                          >
                            *We recommend a high-resolution image (300dpi), CMYK at A6
                            (105x148mm)*
                          </p> */}
                      </div>
                    ) : (
                      <UploadLogoButton
                        text={stage === 5 ? "UPLOAD IMAGE" : "UPLOAD LOGO"}
                        btnID={"upload"}
                        style={"gap-4 w-[224px]"}
                        stage={stage}
                        stateChanger={changeState}
                      />
                    )}
                    <div className="relative">
                      {stage !== 5 && (
                        <div
                          className="flex justify-center items-center gap-2 "
                          onClick={scaleTgl}
                        >
                          <p
                            className="text-[16px]"
                            style={{ fontFamily: "ZapfHumanistBold" }}
                          >
                            LOGO SCALE
                          </p>
                          <div className="bg-white w-8 h-8 rounded-full flex justify-center items-center">
                            <img
                              src={crossArrow}
                              className="w-6 h-6"
                              alt="crossArrow"
                            />
                          </div>
                        </div>
                      )}
                      <ul
                        id="scaleList"
                        className="bg-white py-1 pl-5 pr-10 rounded-xl absolute left-[110%] top-0"
                        style={{ display: "none" }}
                      >
                        <li
                          className="my-2 cursor-pointer"
                          onClick={() => {
                            logoScale("small");
                          }}
                        >
                          Small
                        </li>
                        <li
                          className="my-2 cursor-pointer"
                          onClick={() => {
                            logoScale("medium");
                          }}
                        >
                          Medium
                        </li>
                        <li
                          className="my-2 cursor-pointer"
                          onClick={() => {
                            logoScale("large");
                          }}
                        >
                          Large
                        </li>
                        {/* <li className="my-2 cursor-pointer" onClick={()=>{logoScale("1.8x")}}>1.8x</li> */}
                      </ul>
                    </div>
                  </>
                )}
              </div>
              {/* {stage !== 2 && stage !== 5 && stage !== 3 && ( */}
              {/* {stage == 1 && (
                  <p
                    className="text-[13px] w-[510px] mt-4 ml-12"
                    style={{ fontFamily: "ZapfHumanistBold" }}
                  >
                    *We strongly recommend using a PNG file of your logo with a
                    transparent background to{" "}
                    <p className="ml-[100px]">
                      ensure the best visual effect on all packaging items.
                    </p>
                  </p>
                )} */}
              {stage === 3 && (
                <p
                  className="text-[13px] w-[440px] mt-4 ml-24"
                  style={{ fontFamily: "ZapfHumanistBold" }}
                >
                  *We highly recommend PNG format to use your icon/symbol from
                  your{" "}
                  <span className="ml-12">
                    wordwark (logo) if possible for legibility at a small scale*
                  </span>
                </p>
              )}
            </div>
            <div className="mt-10 w-[500px]">
              <RenderControlers
                id={parseInt(stage)}
                stateChanger={changeState}
                state={state}
                save={saveState}
              />
            </div>
          </section>
        </>
      ) : (
        <h1>loading...</h1>
      )}
    </>
  );
};

export default ColorChanger;
